import { servicePayments } from "../servicePayments";

export const deletePayeeEngagementByPayeeId = async (
  payeeId: string,
  engagementId: string
): Promise<void> => {
  await servicePayments.delete(`/payee/${payeeId}/engagement/${engagementId}`);
};
